var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 0H2.70833C1.21333 0 0 1.21333 0 2.70833V10.2917C0 11.7867 1.21333 13 2.70833 13H10.2917C11.7867 13 13 11.7867 13 10.2917V2.70833C13 1.21333 11.7867 0 10.2917 0ZM11.9167 10.2917C11.9167 11.1854 11.1854 11.9167 10.2917 11.9167H2.70833C1.81458 11.9167 1.08333 11.1854 1.08333 10.2917V2.70833C1.08333 1.81458 1.81458 1.08333 2.70833 1.08333H10.2917C11.1854 1.08333 11.9167 1.81458 11.9167 2.70833V10.2917Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49992 2.70837C4.40909 2.70837 2.70825 4.40921 2.70825 6.50004C2.70825 8.59087 4.40909 10.2917 6.49992 10.2917C8.59075 10.2917 10.2916 8.59087 10.2916 6.50004C10.2916 4.40921 8.59075 2.70837 6.49992 2.70837ZM6.49992 9.20837C5.00492 9.20837 3.79159 7.99504 3.79159 6.50004C3.79159 5.00504 5.00492 3.79171 6.49992 3.79171C7.99492 3.79171 9.20825 5.00504 9.20825 6.50004C9.20825 7.99504 7.99492 9.20837 6.49992 9.20837Z",
    fill: "#E8E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 2.70829C10.8333 3.00745 10.5908 3.24996 10.2917 3.24996C9.99251 3.24996 9.75 3.00745 9.75 2.70829C9.75 2.40913 9.99251 2.16663 10.2917 2.16663C10.5908 2.16663 10.8333 2.40913 10.8333 2.70829Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/instaIcon.a5f876229245c27804310ce563d4d6ae.svg";
export { ForwardRef as ReactComponent };